var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H87.5L100 12.5V100H0V0Z",
    fill: "#FFCC33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55H65V50H75V35H25V50H35V55H20V30H80V55Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.025 80H28.975L25 76.025V60H30V73.975L31.025 75H68.975L70 73.975V60H75V76.025L71.025 80Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 20H37.5V25H62.5V20Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60H40V45H60V60ZM45 55H55V50H45V55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadMini);
export default __webpack_public_path__ + "static/media/head_mini.2e77b63be8d0f934a8d47da6d8af1d15.svg";
export { ForwardRef as ReactComponent };